import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Form, Formik } from "formik";
import { FaTimes } from "react-icons/fa";
import successimg from "../../../assets/images/successimg.png";
import FormikInputField from "../../../Common/FormFields/FormikInputField";
import ValidationFields from "../../../Validation/ValidationFields";
import validationSchema from "../../../Validation/ValidationSchemas";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
const AddPlaylistDialog = ({
  successPopUp,
  toggleSuccessDialog,
  createPlaylist,
}) => {
  return (
    <Dialog
      id="dialogBoxRemove"
      className="dialog-stylee"
      open={successPopUp}
      onClose={toggleSuccessDialog}
    >
      <DialogTitle>
        <div className="row">
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                toggleSuccessDialog(false);
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="clear10"></div>
        <div className="row">
          <div className="col-12 text-center">
            <Formik
              initialValues={{
                playlistName: "",
              }}
              validationSchema={validationSchema.AddPlaylistNameSchema}
              onSubmit={(values) => {
                createPlaylist(values.playlistName);
              }}
            >
              {(formik) => (
                <Form>
                  <FormikTextField
                    label="Playlist Name"
                    formik={formik}
                    fieldName="playlistName"
                    placeholder="Enter Playlist Name"
                    labelFontSize="fs-18"
                  />
                  <div className="d-flex-center">
                    <button
                      type="submit"
                      className={
                        formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                      }
                      disabled={!formik.isValid}
                    >
                      Add
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <div className="clear10"></div>

        <div className="clear10"></div>
      </DialogContent>
    </Dialog>
  );
};

export default AddPlaylistDialog;
